export default function Wave() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
      <path
        fill="#536dfe"
        fill-opacity="1"
        d="M0,128L1440,224L1440,0L0,0Z"
      ></path>
    </svg>
  );
}
